import classNames from 'classnames';
import { Button, ButtonProps } from './Button';
import { CheckIcon } from '../../../../app/assets/icons/buttons';
import { LoaderIcon } from '../../../../app/assets/icons/inputs';
import { IconType } from '../../utils/type.utils';

export type ButtonValidateProps = {
  textStyle?: string;
  Icon?: IconType;
  iconClassName?: string;
} & ButtonProps;

export function ButtonValidate({
  children,
  className,
  disabled,
  textStyle,
  Icon = CheckIcon,
  iconClassName,
  isLoading,
  ...props
}: ButtonValidateProps) {
  const customClassName = classNames(
    'flex items-center justify-center pt-2.5 pb-2.5 w-[130px]',
    {
      'bg-color-success hover:bg-color-light-green hover:border-color-light-green':
        !disabled,
      'bg-color-disabled': disabled,
    },
    {
      'text-white': !disabled,
      'text-color-disabled-text': disabled,
    },
    {
      'fill-white': !disabled,
      'fill-color-disabled-text': disabled,
    },
    className,
  );
  const customIconClassName = classNames('mr-0.5', iconClassName);
  const customTextStyle = classNames('text-sm uppercase', textStyle);

  return (
    <Button className={customClassName} disabled={disabled} {...props}>
      {isLoading ? (
        <LoaderIcon
          className="animate-spin fill-white"
          height={20}
          width={20}
        />
      ) : (
        <>
          <Icon className={customIconClassName} height={20} width={20} />
          <p className={customTextStyle}>{children}</p>
        </>
      )}
    </Button>
  );
}
